export const MEDIA_QUERIES = {
    sm: '@media (min-width: 576px)',
    md: '@media (min-width: 768px)',
    lg: '@media (min-width: 992px)',
    xl: '@media (min-width: 1200px)',
    xxl: '@media (min-width: 1400px)'
};

// Alternative export if you prefer individual constants
export const SM = '@media (min-width: 576px)';
export const MD = '@media (min-width: 768px)';
export const LG = '@media (min-width: 992px)';
export const XL = '@media (min-width: 1200px)';
export const XXL = '@media (min-width: 1400px)';